import { defineComponent as b, openBlock as d, createElementBlock as u, mergeProps as w, toHandlers as N, toDisplayString as le, defineAsyncComponent as W, resolveComponent as y, Fragment as C, createBlock as k, createCommentVNode as f, renderList as A, withCtx as ne, createVNode as B, h as Se, renderSlot as P, createElementVNode as Q, normalizeStyle as X, normalizeClass as Ce, markRaw as Je } from "vue";
function z(e = {}, t, n) {
  const o = {};
  for (const i in e) {
    if (!e[i] || n && !i.startsWith(t))
      continue;
    const r = n ? i.replace(t, "") : i;
    o[r] = e[i];
  }
  return o;
}
const Ye = b({
  name: "builder-button",
  props: ["attributes", "text", "link", "openLinkInNewTab"],
  data() {
    return { filterAttrs: z };
  },
  methods: {
    _classStringToObject(e) {
      const t = {};
      if (typeof e != "string")
        return t;
      const n = e.trim().split(/\s+/);
      for (const o of n)
        t[o] = !0;
      return t;
    }
  }
});
const g = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, Qe = ["href", "target"];
function Xe(e, t, n, o, i, r) {
  return e.link ? (d(), u("a", w({
    key: 0,
    href: e.link,
    target: e.openLinkInNewTab ? "_blank" : void 0,
    role: "button"
  }, e.filterAttrs(e.attributes, "v-on:", !1), N(e.filterAttrs(e.attributes, "v-on:", !0), !0)), le(e.text), 17, Qe)) : (d(), u("button", w({
    key: 1,
    style: e.attributes.style,
    class: e._classStringToObject(e.attributes.class + " button-21azgz5avex")
  }, e.filterAttrs(e.attributes, "v-on:", !1), N(e.filterAttrs(e.attributes, "v-on:", !0), !0)), le(e.text), 17));
}
const Ze = /* @__PURE__ */ g(Ye, [["render", Xe], ["__scopeId", "data-v-becdf225"], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/button/button.vue"]]), et = Symbol(), Z = {
  Builder: {
    content: null,
    context: {},
    localState: void 0,
    rootSetState() {
    },
    rootState: {},
    apiKey: null,
    apiVersion: void 0,
    componentInfos: {},
    inheritedStyles: {}
  },
  key: et
}, tt = Symbol(), we = {
  Components: { registeredComponents: {} },
  key: tt
};
function nt(e) {
  var t;
  return {
    ...(t = e.component) == null ? void 0 : t.options,
    ...e.options,
    builderBlock: e
  };
}
const x = "vue3", ot = (e) => e.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase(), T = (e) => e != null, it = (e) => Object.entries(e).map(([n, o]) => {
  if (typeof o == "string")
    return `${ot(n)}: ${o};`;
}).filter(T), rt = (e) => it(e).join(`
`), J = ({
  mediaQuery: e,
  className: t,
  styles: n
}) => {
  const o = `.${t} {
    ${rt(n)}
  }`;
  return e ? `${e} {
      ${o}
    }` : o;
}, M = "[Builder.io]: ", $ = {
  log: (...e) => console.log(M, ...e),
  error: (...e) => console.error(M, ...e),
  warn: (...e) => console.warn(M, ...e),
  debug: (...e) => console.debug(M, ...e)
};
function v() {
  return typeof window < "u" && typeof document < "u";
}
function st() {
  return v() && window.self !== window.top;
}
function R() {
  return st() && window.location.search.indexOf("builder.frameEditing=") !== -1;
}
const at = () => {
  if (v()) {
    const e = new URL(location.href);
    return e.pathname === "" && (e.pathname = "/"), e;
  } else
    return console.warn("Cannot get location for tracking in non-browser environment"), null;
}, lt = () => typeof navigator == "object" && navigator.userAgent || "", Ie = () => {
  const e = lt(), t = {
    Android() {
      return e.match(/Android/i);
    },
    BlackBerry() {
      return e.match(/BlackBerry/i);
    },
    iOS() {
      return e.match(/iPhone|iPod/i);
    },
    Opera() {
      return e.match(/Opera Mini/i);
    },
    Windows() {
      return e.match(/IEMobile/i) || e.match(/WPDesktop/i);
    },
    any() {
      return t.Android() || t.BlackBerry() || t.iOS() || t.Opera() || t.Windows() || x === "reactNative";
    }
  }, n = e.match(/Tablet|iPad/i), o = at();
  return {
    urlPath: o == null ? void 0 : o.pathname,
    host: (o == null ? void 0 : o.host) || (o == null ? void 0 : o.hostname),
    device: n ? "tablet" : t.any() ? "mobile" : "desktop"
  };
}, ct = ({
  builder: e,
  context: t,
  event: n,
  state: o
}) => Object.entries({
  state: o,
  Builder: e,
  builder: e,
  context: t,
  event: n
}), dt = () => ({
  isEditing: R(),
  isBrowser: v(),
  isServer: !v(),
  getUserAttributes: () => Ie()
}), ut = (e, {
  isExpression: t = !0
}) => t && !(e.includes(";") || e.includes(" return ") || e.trim().startsWith("return ")) ? `return (${e});` : e, ce = ({
  code: e,
  builder: t,
  context: n,
  event: o,
  localState: i,
  rootSetState: r,
  rootState: s
}) => {
  const a = ct({
    builder: t,
    context: n,
    event: o,
    state: pt(s, i, r)
  });
  return new Function(...a.map(([l]) => l), e)(...a.map(([, l]) => l));
};
function pt(e, t, n) {
  if (e === t)
    throw new Error("rootState === localState");
  return new Proxy(e, {
    get: (o, i) => t && i in t ? t[i] : e[i],
    set: (o, i, r) => {
      if (t && i in t)
        throw new Error("Writing to local state is not allowed as it is read-only.");
      return e[i] = r, n == null || n(e), !0;
    }
  });
}
const mt = (e) => (v(), ce(e));
function K({
  code: e,
  context: t,
  localState: n,
  rootState: o,
  rootSetState: i,
  event: r,
  isExpression: s = !0
}) {
  if (e === "") {
    $.warn("Skipping evaluation of empty code block.");
    return;
  }
  const a = {
    code: ut(e, {
      isExpression: s
    }),
    builder: dt(),
    context: t,
    event: r,
    rootSetState: i,
    rootState: o,
    localState: n
  };
  try {
    return mt(a);
  } catch (l) {
    $.error("Failed code evaluation: " + l.message, {
      code: e
    });
    return;
  }
}
const F = (e) => JSON.parse(JSON.stringify(e)), ht = (e, t, n) => {
  if (Object(e) !== e)
    return e;
  const o = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g);
  return o.slice(0, -1).reduce((i, r, s) => Object(i[r]) === i[r] ? i[r] : i[r] = Math.abs(Number(o[s + 1])) >> 0 === +o[s + 1] ? [] : {}, e)[o[o.length - 1]] = n, e;
};
const ft = ({
  block: e,
  context: t,
  localState: n,
  rootState: o,
  rootSetState: i
}) => {
  if (!e.bindings)
    return e;
  const r = F(e), s = {
    ...r,
    properties: {
      ...r.properties
    },
    actions: {
      ...r.actions
    }
  };
  for (const a in e.bindings) {
    const l = e.bindings[a], c = K({
      code: l,
      localState: n,
      rootState: o,
      rootSetState: i,
      context: t
    });
    ht(s, a, c);
  }
  return s;
};
function D({
  block: e,
  context: t,
  shouldEvaluateBindings: n,
  localState: o,
  rootState: i,
  rootSetState: r
}) {
  const s = e;
  return n ? ft({
    block: s,
    localState: o,
    rootState: i,
    rootSetState: r,
    context: t
  }) : s;
}
const bt = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"], gt = (e) => typeof e == "string" && bt.includes(e.toLowerCase()), yt = ({
  block: e,
  context: t,
  registeredComponents: n
}) => {
  var r;
  const o = (r = D({
    block: e,
    localState: t.localState,
    rootState: t.rootState,
    rootSetState: t.rootSetState,
    context: t.context,
    shouldEvaluateBindings: !1
  }).component) == null ? void 0 : r.name;
  if (!o)
    return null;
  const i = n[o];
  if (i)
    return i;
  console.warn(`
      Could not find a registered component named "${o}". 
      If you registered it, is the file that registered it imported by the file that needs to render it?`);
}, kt = ({
  block: e,
  context: t
}) => {
  const {
    repeat: n,
    ...o
  } = e;
  if (!(n != null && n.collection))
    return;
  const i = K({
    code: n.collection,
    localState: t.localState,
    rootState: t.rootState,
    rootSetState: t.rootSetState,
    context: t.context
  });
  if (!Array.isArray(i))
    return;
  const r = n.collection.split(".").pop(), s = n.itemName || (r ? r + "Item" : "item");
  return i.map((l, c) => ({
    context: {
      ...t,
      localState: {
        ...t.localState,
        $index: c,
        $item: l,
        [s]: l,
        [`$${s}Index`]: c
      }
    },
    block: o
  }));
}, vt = () => Promise.resolve().then(() => Et).then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component BlockStyles at ./components/block-styles.vue",
    e
  ), e;
}), St = () => import("./block-wrapper.1377d486.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component BlockWrapper at ./components/block-wrapper.vue",
    e
  ), e;
}), Ct = () => import("./component-ref.0df2ace0.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component ComponentRef at ./components/component-ref/component-ref.vue",
    e
  ), e;
}), wt = () => import("./repeated-block.055d09e9.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component RepeatedBlock at ./components/repeated-block.vue",
    e
  ), e;
}), It = b({
  name: "block",
  components: {
    ComponentRef: W(Ct),
    BlockWrapper: W(St),
    RepeatedBlock: W(wt),
    BlockStyles: W(vt)
  },
  props: ["block", "context", "registeredComponents"],
  data() {
    return { childrenContext: this.context, isEmptyHtmlElement: gt };
  },
  computed: {
    blockComponent() {
      return yt({
        block: this.block,
        context: this.context,
        registeredComponents: this.registeredComponents
      });
    },
    repeatItem() {
      return kt({
        block: this.block,
        context: this.context
      });
    },
    processedBlock() {
      var e;
      return (e = this.block.repeat) != null && e.collection ? this.block : D({
        block: this.block,
        localState: this.context.localState,
        rootState: this.context.rootState,
        rootSetState: this.context.rootSetState,
        context: this.context.context,
        shouldEvaluateBindings: !0
      });
    },
    Tag() {
      return this.block.tagName || "div";
    },
    canShowBlock() {
      var n, o;
      if ((n = this.block.repeat) != null && n.collection)
        return !!((o = this.repeatItem) != null && o.length);
      const e = "hide" in this.processedBlock ? this.processedBlock.hide : !1;
      return ("show" in this.processedBlock ? this.processedBlock.show : !0) && !e;
    },
    childrenWithoutParentComponent() {
      var t, n;
      return !((t = this.blockComponent) != null && t.component) && !this.repeatItem ? (n = this.processedBlock.children) != null ? n : [] : [];
    },
    componentRefProps() {
      var e, t, n, o, i, r;
      return {
        blockChildren: (e = this.processedBlock.children) != null ? e : [],
        componentRef: (t = this.blockComponent) == null ? void 0 : t.component,
        componentOptions: {
          ...nt(this.processedBlock),
          builderContext: this.context,
          ...((n = this.blockComponent) == null ? void 0 : n.name) === "Symbol" || ((o = this.blockComponent) == null ? void 0 : o.name) === "Columns" ? {
            builderComponents: this.registeredComponents
          } : {}
        },
        context: this.childrenContext,
        registeredComponents: this.registeredComponents,
        builderBlock: this.processedBlock,
        includeBlockProps: ((i = this.blockComponent) == null ? void 0 : i.noWrap) === !0,
        isInteractive: !((r = this.blockComponent) != null && r.isRSC)
      };
    }
  }
});
function $t(e, t, n, o, i, r) {
  var h;
  const s = y("block-wrapper"), a = y("repeated-block"), l = y("component-ref"), c = y("block", !0), p = y("block-styles");
  return e.canShowBlock ? (d(), u(C, { key: 0 }, [
    (h = e.blockComponent) != null && h.noWrap ? (d(), k(l, {
      key: 1,
      componentRef: e.componentRefProps.componentRef,
      componentOptions: e.componentRefProps.componentOptions,
      blockChildren: e.componentRefProps.blockChildren,
      context: e.componentRefProps.context,
      registeredComponents: e.componentRefProps.registeredComponents,
      builderBlock: e.componentRefProps.builderBlock,
      includeBlockProps: e.componentRefProps.includeBlockProps,
      isInteractive: e.componentRefProps.isInteractive
    }, null, 8, ["componentRef", "componentOptions", "blockChildren", "context", "registeredComponents", "builderBlock", "includeBlockProps", "isInteractive"])) : (d(), u(C, { key: 0 }, [
      e.isEmptyHtmlElement(e.Tag) ? (d(), k(s, {
        key: 0,
        Wrapper: e.Tag,
        block: e.processedBlock,
        context: e.context,
        hasChildren: !1
      }, null, 8, ["Wrapper", "block", "context"])) : f("v-if", !0),
      !e.isEmptyHtmlElement(e.Tag) && e.repeatItem ? (d(!0), u(C, { key: 1 }, A(e.repeatItem, (m, S) => (d(), k(a, {
        key: S,
        repeatContext: m.context,
        block: m.block,
        registeredComponents: e.registeredComponents
      }, null, 8, ["repeatContext", "block", "registeredComponents"]))), 128)) : f("v-if", !0),
      !e.isEmptyHtmlElement(e.Tag) && !e.repeatItem ? (d(), k(s, {
        key: 2,
        Wrapper: e.Tag,
        block: e.processedBlock,
        context: e.context,
        hasChildren: !0
      }, {
        default: ne(() => [
          B(l, {
            componentRef: e.componentRefProps.componentRef,
            componentOptions: e.componentRefProps.componentOptions,
            blockChildren: e.componentRefProps.blockChildren,
            context: e.componentRefProps.context,
            registeredComponents: e.componentRefProps.registeredComponents,
            builderBlock: e.componentRefProps.builderBlock,
            includeBlockProps: e.componentRefProps.includeBlockProps,
            isInteractive: e.componentRefProps.isInteractive
          }, null, 8, ["componentRef", "componentOptions", "blockChildren", "context", "registeredComponents", "builderBlock", "includeBlockProps", "isInteractive"]),
          (d(!0), u(C, null, A(e.childrenWithoutParentComponent, (m, S) => (d(), k(c, {
            key: "block-" + m.id,
            block: m,
            context: e.childrenContext,
            registeredComponents: e.registeredComponents
          }, null, 8, ["block", "context", "registeredComponents"]))), 128)),
          (d(!0), u(C, null, A(e.childrenWithoutParentComponent, (m, S) => (d(), k(p, {
            key: "block-style-" + m.id,
            block: m,
            context: e.childrenContext
          }, null, 8, ["block", "context"]))), 128))
        ]),
        _: 1
      }, 8, ["Wrapper", "block", "context"])) : f("v-if", !0)
    ], 64))
  ], 64)) : f("v-if", !0);
}
const $e = /* @__PURE__ */ g(It, [["render", $t], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/block/block.vue"]]), oi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $e
}, Symbol.toStringTag, { value: "Module" })), Re = {
  small: {
    min: 320,
    default: 321,
    max: 640
  },
  medium: {
    min: 641,
    default: 642,
    max: 991
  },
  large: {
    min: 990,
    default: 991,
    max: 1200
  }
}, de = (e, t = Re) => `@media (max-width: ${t[e].max}px)`, Te = ({
  small: e,
  medium: t
}) => {
  const n = F(Re);
  if (!e || !t)
    return n;
  const o = Math.floor(e / 2);
  n.small = {
    max: e,
    min: o,
    default: o + 1
  };
  const i = n.small.max + 1;
  n.medium = {
    max: t,
    min: i,
    default: i + 1
  };
  const r = n.medium.max + 1;
  return n.large = {
    max: 2e3,
    min: r,
    default: r + 1
  }, n;
}, Rt = b({
  render() {
    return Se("style", { id: this.id, innerHTML: this.styles });
  },
  name: "inlined-styles",
  props: ["styles", "id"]
}), q = /* @__PURE__ */ g(Rt, [["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/inlined-styles.vue"]]), Tt = b({
  name: "block-styles",
  components: { InlinedStyles: q },
  props: ["block", "context"],
  data() {
    return { TARGET: x };
  },
  computed: {
    canShowBlock() {
      const e = D({
        block: this.block,
        localState: this.context.localState,
        rootState: this.context.rootState,
        rootSetState: this.context.rootSetState,
        context: this.context.context,
        shouldEvaluateBindings: !0
      });
      return T(e.hide) ? !e.hide : T(e.show) ? e.show : !0;
    },
    css() {
      var h;
      const e = D({
        block: this.block,
        localState: this.context.localState,
        rootState: this.context.rootState,
        rootSetState: this.context.rootSetState,
        context: this.context.context,
        shouldEvaluateBindings: !0
      }), t = e.responsiveStyles, n = this.context.content, o = Te(
        ((h = n == null ? void 0 : n.meta) == null ? void 0 : h.breakpoints) || {}
      ), i = t == null ? void 0 : t.large, r = t == null ? void 0 : t.medium, s = t == null ? void 0 : t.small, a = e.id;
      if (!a)
        return "";
      const l = i ? J({
        className: a,
        styles: i
      }) : "", c = r ? J({
        className: a,
        styles: r,
        mediaQuery: de(
          "medium",
          o
        )
      }) : "", p = s ? J({
        className: a,
        styles: s,
        mediaQuery: de(
          "small",
          o
        )
      }) : "";
      return [l, c, p].join(" ");
    }
  }
});
function xt(e, t, n, o, i, r) {
  const s = y("inlined-styles");
  return e.TARGET !== "reactNative" && e.css && e.canShowBlock ? (d(), k(s, {
    key: 0,
    styles: e.css
  }, null, 8, ["styles"])) : f("v-if", !0);
}
const xe = /* @__PURE__ */ g(Tt, [["render", xt], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/block/components/block-styles.vue"]]), Et = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xe
}, Symbol.toStringTag, { value: "Module" })), Pt = b({
  name: "builder-blocks-wrapper",
  props: ["blocks", "parent", "path", "styleProp"],
  computed: {
    className() {
      var e;
      return "builder-blocks" + ((e = this.blocks) != null && e.length ? "" : " no-blocks");
    }
  },
  methods: {
    onClick() {
      var e, t;
      R() && !((e = this.blocks) != null && e.length) && ((t = window.parent) == null || t.postMessage(
        {
          type: "builder.clickEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.path
          }
        },
        "*"
      ));
    },
    onMouseEnter() {
      var e, t;
      R() && !((e = this.blocks) != null && e.length) && ((t = window.parent) == null || t.postMessage(
        {
          type: "builder.hoverEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.path
          }
        },
        "*"
      ));
    },
    _classStringToObject(e) {
      const t = {};
      if (typeof e != "string")
        return t;
      const n = e.trim().split(/\s+/);
      for (const o of n)
        t[o] = !0;
      return t;
    }
  }
});
const At = ["builder-path", "builder-parent-id"];
function Bt(e, t, n, o, i, r) {
  return d(), u("div", w({
    class: e._classStringToObject(e.className + " div-178o76acnws"),
    "builder-path": e.path,
    "builder-parent-id": e.parent,
    style: e.styleProp,
    onClick: t[0] || (t[0] = (s) => e.onClick()),
    onMouseenter: t[1] || (t[1] = (s) => e.onMouseEnter()),
    onKeypress: t[2] || (t[2] = (s) => e.onClick())
  }, {}), [
    P(e.$slots, "default", {}, void 0, !0)
  ], 16, At);
}
const Vt = /* @__PURE__ */ g(Pt, [["render", Bt], ["__scopeId", "data-v-1f8aab9f"], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/blocks/blocks-wrapper.vue"]]), _t = b({
  name: "builder-blocks",
  components: {
    BlocksWrapper: Vt,
    Block: $e,
    BlockStyles: xe
  },
  props: [
    "blocks",
    "parent",
    "path",
    "styleProp",
    "context",
    "registeredComponents"
  ],
  inject: {
    builderContext: Z.key,
    componentsContext: we.key
  }
});
function Ot(e, t, n, o, i, r) {
  const s = y("block"), a = y("block-styles"), l = y("blocks-wrapper");
  return d(), k(l, {
    blocks: e.blocks,
    parent: e.parent,
    path: e.path,
    styleProp: e.styleProp
  }, {
    default: ne(() => [
      e.blocks ? (d(!0), u(C, { key: 0 }, A(e.blocks, (c, p) => (d(), k(s, {
        key: "render-block-" + c.id,
        block: c,
        context: e.context || e.builderContext,
        registeredComponents: e.registeredComponents || e.componentsContext.registeredComponents
      }, null, 8, ["block", "context", "registeredComponents"]))), 128)) : f("v-if", !0),
      e.blocks ? (d(!0), u(C, { key: 1 }, A(e.blocks, (c, p) => (d(), k(a, {
        key: "block-style-" + c.id,
        block: c,
        context: e.context || e.builderContext
      }, null, 8, ["block", "context"]))), 128)) : f("v-if", !0)
    ]),
    _: 1
  }, 8, ["blocks", "parent", "path", "styleProp"]);
}
const oe = /* @__PURE__ */ g(_t, [["render", Ot], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/blocks/blocks.vue"]]), jt = b({
  name: "builder-columns",
  components: { InlinedStyles: q, Blocks: oe },
  props: [
    "js",
    "space",
    "columns",
    "stackColumnsAt",
    "reverseColumnsWhenStacked",
    "builderContext",
    "builderBlock",
    "builderComponents"
  ],
  data() {
    return {
      gutterSize: typeof this.space == "number" ? this.space || 0 : 20,
      cols: this.columns || [],
      stackAt: this.stackColumnsAt || "tablet",
      flexDir: this.stackColumnsAt === "never" ? "row" : this.reverseColumnsWhenStacked ? "column-reverse" : "column",
      TARGET: x
    };
  },
  computed: {
    columnsCssVars() {
      return {
        "--flex-dir": this.flexDir,
        "--flex-dir-tablet": this.getTabletStyle({
          stackedStyle: this.flexDir,
          desktopStyle: "row"
        })
      };
    },
    columnsStyles() {
      return `
        @media (max-width: ${this.getWidthForBreakpointSize("medium")}px) {
          .${this.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir-tablet);
            align-items: stretch;
          }

          .${this.builderBlock.id}-breakpoints > .builder-column {
            width: var(--column-width-tablet) !important;
            margin-left: var(--column-margin-left-tablet) !important;
          }
        }

        @media (max-width: ${this.getWidthForBreakpointSize("small")}px) {
          .${this.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir);
            align-items: stretch;
          }

          .${this.builderBlock.id}-breakpoints > .builder-column {
            width: var(--column-width-mobile) !important;
            margin-left: var(--column-margin-left-mobile) !important;
          }
        },
      `;
    }
  },
  methods: {
    getWidth(e) {
      var t;
      return ((t = this.cols[e]) == null ? void 0 : t.width) || 100 / this.cols.length;
    },
    getColumnCssWidth(e) {
      const t = this.gutterSize * (this.cols.length - 1) / this.cols.length;
      return `calc(${this.getWidth(e)}% - ${t}px)`;
    },
    getTabletStyle({
      stackedStyle: e,
      desktopStyle: t
    }) {
      return this.stackAt === "tablet" ? e : t;
    },
    getMobileStyle({
      stackedStyle: e,
      desktopStyle: t
    }) {
      return this.stackAt === "never" ? t : e;
    },
    columnCssVars(e) {
      const t = e === 0 ? 0 : this.gutterSize, n = this.getColumnCssWidth(e), o = `${t}px`, i = "100%", r = 0;
      return {
        width: n,
        ["margin-left"]: o,
        "--column-width-mobile": this.getMobileStyle({
          stackedStyle: i,
          desktopStyle: n
        }),
        "--column-margin-left-mobile": this.getMobileStyle({
          stackedStyle: r,
          desktopStyle: o
        }),
        "--column-width-tablet": this.getTabletStyle({
          stackedStyle: i,
          desktopStyle: n
        }),
        "--column-margin-left-tablet": this.getTabletStyle({
          stackedStyle: r,
          desktopStyle: o
        })
      };
    },
    getWidthForBreakpointSize(e) {
      var n, o;
      return Te(
        ((o = (n = this.builderContext.content) == null ? void 0 : n.meta) == null ? void 0 : o.breakpoints) || {}
      )[e].max;
    },
    _classStringToObject(e) {
      const t = {};
      if (typeof e != "string")
        return t;
      const n = e.trim().split(/\s+/);
      for (const o of n)
        t[o] = !0;
      return t;
    }
  }
});
function Nt(e, t, n, o, i, r) {
  const s = y("inlined-styles"), a = y("blocks");
  return d(), u("div", w({
    class: e._classStringToObject(
      `builder-columns ${e.builderBlock.id}-breakpoints div-16nol0lwi20`
    ),
    style: e.columnsCssVars
  }, {}), [
    e.TARGET !== "reactNative" ? (d(), k(s, {
      key: 0,
      styles: e.columnsStyles
    }, null, 8, ["styles"])) : f("v-if", !0),
    (d(!0), u(C, null, A(e.columns, (l, c) => (d(), u("div", w({
      key: c,
      class: "builder-column div-16nol0lwi20-2",
      style: e.columnCssVars(c)
    }, {}), [
      B(a, {
        path: `component.options.columns.${c}.blocks`,
        parent: e.builderBlock.id,
        styleProp: {
          flexGrow: "1"
        },
        context: e.builderContext,
        registeredComponents: e.builderComponents,
        blocks: l.blocks
      }, null, 8, ["path", "parent", "context", "registeredComponents", "blocks"])
    ], 16))), 128))
  ], 16);
}
const Ut = /* @__PURE__ */ g(jt, [["render", Nt], ["__scopeId", "data-v-7be099dc"], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/columns/columns.vue"]]), Ft = b({
  name: "builder-fragment-component",
  props: []
});
function Wt(e, t, n, o, i, r) {
  return d(), u("span", null, [
    P(e.$slots, "default")
  ]);
}
const Mt = /* @__PURE__ */ g(Ft, [["render", Wt], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/fragment/fragment.vue"]]);
function ue(e) {
  return e.replace(/http(s)?:/, "");
}
function Lt(e = "", t, n) {
  const o = new RegExp("([?&])" + t + "=.*?(&|$)", "i"), i = e.indexOf("?") !== -1 ? "&" : "?";
  return e.match(o) ? e.replace(o, "$1" + t + "=" + encodeURIComponent(n) + "$2") : e + i + t + "=" + encodeURIComponent(n);
}
function Ht(e, t) {
  if (!e || !(e != null && e.match(/cdn\.shopify\.com/)) || !t)
    return e;
  if (t === "master")
    return ue(e);
  const n = e.match(/(_\d+x(\d+)?)?(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?)/i);
  if (n) {
    const o = e.split(n[0]), i = n[3], r = t.match("x") ? t : `${t}x`;
    return ue(`${o[0]}_${r}${i}`);
  }
  return null;
}
function Y(e) {
  if (!e)
    return e;
  const t = [100, 200, 400, 800, 1200, 1600, 2e3];
  if (e.match(/builder\.io/)) {
    let n = e;
    const o = Number(e.split("?width=")[1]);
    return isNaN(o) || (n = `${n} ${o}w`), t.filter((i) => i !== o).map((i) => `${Lt(e, "width", i)} ${i}w`).concat([n]).join(", ");
  }
  return e.match(/cdn\.shopify\.com/) ? t.map((n) => [Ht(e, `${n}x${n}`), n]).filter(([n]) => !!n).map(([n, o]) => `${n} ${o}w`).concat([e]).join(", ") : e;
}
const Kt = b({
  name: "builder-image",
  props: [
    "image",
    "src",
    "srcset",
    "noWebp",
    "aspectRatio",
    "altText",
    "backgroundPosition",
    "backgroundSize",
    "className",
    "sizes",
    "builderBlock",
    "fitContent"
  ],
  computed: {
    srcSetToUse() {
      var n;
      const t = this.image || this.src;
      if (!t || !(t.match(/builder\.io/) || t.match(/cdn\.shopify\.com/)))
        return this.srcset;
      if (this.srcset && ((n = this.image) == null ? void 0 : n.includes("builder.io/api/v1/image"))) {
        if (!this.srcset.includes(this.image.split("?")[0]))
          return console.debug("Removed given srcset"), Y(t);
      } else if (this.image && !this.srcset)
        return Y(t);
      return Y(t);
    },
    webpSrcSet() {
      var e;
      return ((e = this.srcSetToUse) == null ? void 0 : e.match(/builder\.io/)) && !this.noWebp ? this.srcSetToUse.replace(/\?/g, "?format=webp&") : "";
    },
    aspectRatioCss() {
      const e = {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: "0px",
        top: "0px"
      };
      return this.aspectRatio ? e : void 0;
    }
  },
  methods: {
    _classStringToObject(e) {
      const t = {};
      if (typeof e != "string")
        return t;
      const n = e.trim().split(/\s+/);
      for (const o of n)
        t[o] = !0;
      return t;
    }
  }
});
const Dt = ["srcset"], zt = ["alt", "role", "src", "srcset", "sizes"], qt = {
  key: 2,
  class: "div-1be3j8m9ewb-2"
};
function Gt(e, t, n, o, i, r) {
  var s, a, l, c;
  return d(), u(C, null, [
    Q("picture", null, [
      e.webpSrcSet ? (d(), u("source", {
        key: 0,
        type: "image/webp",
        srcset: e.webpSrcSet
      }, null, 8, Dt)) : f("v-if", !0),
      Q("img", {
        loading: "lazy",
        alt: e.altText,
        role: e.altText ? "presentation" : void 0,
        style: X({
          objectPosition: e.backgroundPosition || "center",
          objectFit: e.backgroundSize || "cover",
          ...e.aspectRatioCss
        }),
        class: Ce(
          e._classStringToObject(
            "builder-image" + (e.className ? " " + e.className : "") + " img-1be3j8m9ewb"
          )
        ),
        src: e.image,
        srcset: e.srcSetToUse,
        sizes: e.sizes
      }, null, 14, zt)
    ]),
    e.aspectRatio && !(((a = (s = e.builderBlock) == null ? void 0 : s.children) == null ? void 0 : a.length) && e.fitContent) ? (d(), u("div", {
      key: 0,
      class: "builder-image-sizer div-1be3j8m9ewb",
      style: X({
        paddingTop: e.aspectRatio * 100 + "%"
      })
    }, null, 4)) : f("v-if", !0),
    ((c = (l = e.builderBlock) == null ? void 0 : l.children) == null ? void 0 : c.length) && e.fitContent ? P(e.$slots, "default", { key: 1 }, void 0, !0) : f("v-if", !0),
    !e.fitContent && e.$slots.default ? (d(), u("div", qt, [
      P(e.$slots, "default", {}, void 0, !0)
    ])) : f("v-if", !0)
  ], 64);
}
const Jt = /* @__PURE__ */ g(Kt, [["render", Gt], ["__scopeId", "data-v-58ca75d1"], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/image/image.vue"]]), Yt = b({
  name: "builder-section-component",
  props: ["attributes", "maxWidth"],
  data() {
    return { filterAttrs: z };
  }
});
function Qt(e, t, n, o, i, r) {
  return d(), u("section", w({
    style: {
      width: "100%",
      alignSelf: "stretch",
      flexGrow: 1,
      boxSizing: "border-box",
      maxWidth: e.maxWidth || 1200,
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      marginLeft: "auto",
      marginRight: "auto"
    }
  }, e.filterAttrs(e.attributes, "v-on:", !1), N(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    P(e.$slots, "default")
  ], 16);
}
const Xt = /* @__PURE__ */ g(Yt, [["render", Qt], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/section/section.vue"]]), Zt = (e) => {
  if (e === "localhost" || e === "127.0.0.1")
    return e;
  const t = e.split(".");
  return t.length > 2 ? t.slice(1).join(".") : e;
}, Ee = ({
  name: e,
  canTrack: t
}) => {
  var n;
  try {
    return t ? (n = document.cookie.split("; ").find((o) => o.startsWith(`${e}=`))) == null ? void 0 : n.split("=")[1] : void 0;
  } catch (o) {
    $.warn("[COOKIE] GET error: ", (o == null ? void 0 : o.message) || o);
    return;
  }
}, Pe = async (e) => Ee(e), en = (e) => e.map(([t, n]) => n ? `${t}=${n}` : t).filter(T).join("; "), tn = [["secure", ""], ["SameSite", "None"]], nn = ({
  name: e,
  value: t,
  expires: n
}) => {
  const i = (v() ? location.protocol === "https:" : !0) ? tn : [[]], r = n ? [["expires", n.toUTCString()]] : [[]], s = [[e, t], ...r, ["path", "/"], ["domain", Zt(window.location.hostname)], ...i];
  return en(s);
}, Ae = async ({
  name: e,
  value: t,
  expires: n,
  canTrack: o
}) => {
  try {
    if (!o)
      return;
    const i = nn({
      name: e,
      value: t,
      expires: n
    });
    document.cookie = i;
  } catch (i) {
    $.warn("[COOKIE] SET error: ", (i == null ? void 0 : i.message) || i);
  }
}, on = "builder.tests", ie = (e) => `${on}.${e}`, rn = ({
  contentId: e
}) => Pe({
  name: ie(e),
  canTrack: !0
}), sn = ({
  contentId: e
}) => Ee({
  name: ie(e),
  canTrack: !0
}), an = ({
  contentId: e,
  value: t
}) => Ae({
  name: ie(e),
  value: t,
  canTrack: !0
}), Be = (e) => T(e.id) && T(e.variations) && Object.keys(e.variations).length > 0, ln = ({
  id: e,
  variations: t
}) => {
  var i;
  let n = 0;
  const o = Math.random();
  for (const r in t) {
    const s = (i = t[r]) == null ? void 0 : i.testRatio;
    if (n += s, o < n)
      return r;
  }
  return e;
}, Ve = (e) => {
  const t = ln(e);
  return an({
    contentId: e.id,
    value: t
  }).catch((n) => {
    $.error("could not store A/B test variation: ", n);
  }), t;
}, _e = ({
  item: e,
  testGroupId: t
}) => {
  const n = e.variations[t];
  return t === e.id || !n ? {
    testVariationId: e.id,
    testVariationName: "Default"
  } : {
    data: n.data,
    testVariationId: n.id,
    testVariationName: n.name || (n.id === e.id ? "Default" : "")
  };
}, cn = ({
  item: e,
  canTrack: t
}) => {
  if (!t)
    return e;
  if (!e)
    return;
  if (!Be(e))
    return e;
  const n = sn({
    contentId: e.id
  }) || Ve({
    variations: e.variations,
    id: e.id
  }), o = _e({
    item: e,
    testGroupId: n
  });
  return {
    ...e,
    ...o
  };
}, dn = async ({
  item: e,
  canTrack: t
}) => {
  if (!t || !Be(e))
    return e;
  const o = await rn({
    contentId: e.id
  }) || Ve({
    variations: e.variations,
    id: e.id
  }), i = _e({
    item: e,
    testGroupId: o
  });
  return {
    ...e,
    ...i
  };
}, U = (e) => T(e) ? e : !0, un = {
  name: "Core:Button",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13",
  defaultStyles: {
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#000000",
    color: "white",
    borderRadius: "4px",
    textAlign: "center",
    cursor: "pointer"
  },
  inputs: [{
    name: "text",
    type: "text",
    defaultValue: "Click me!",
    bubble: !0
  }, {
    name: "link",
    type: "url",
    bubble: !0
  }, {
    name: "openLinkInNewTab",
    type: "boolean",
    defaultValue: !1,
    friendlyName: "Open link in new tab"
  }],
  static: !0,
  noWrap: !0
}, pn = {
  name: "Columns",
  isRSC: !0,
  inputs: [{
    name: "columns",
    type: "array",
    broadcast: !0,
    subFields: [{
      name: "blocks",
      type: "array",
      hideFromUI: !0,
      defaultValue: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }, {
      name: "width",
      type: "number",
      hideFromUI: !0,
      helperText: "Width %, e.g. set to 50 to fill half of the space"
    }, {
      name: "link",
      type: "url",
      helperText: "Optionally set a url that clicking this column will link to"
    }],
    defaultValue: [{
      blocks: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }, {
      blocks: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }],
    onChange: (e) => {
      function t() {
        n.forEach((o) => {
          o.delete("width");
        });
      }
      const n = e.get("columns");
      Array.isArray(n) && !!n.find((i) => i.get("width")) && (!!n.find((r) => !r.get("width")) || n.reduce((a, l) => a + l.get("width"), 0) !== 100) && t();
    }
  }, {
    name: "space",
    type: "number",
    defaultValue: 20,
    helperText: "Size of gap between columns",
    advanced: !0
  }, {
    name: "stackColumnsAt",
    type: "string",
    defaultValue: "tablet",
    helperText: "Convert horizontal columns to vertical at what device size",
    enum: ["tablet", "mobile", "never"],
    advanced: !0
  }, {
    name: "reverseColumnsWhenStacked",
    type: "boolean",
    defaultValue: !1,
    helperText: "When stacking columns for mobile devices, reverse the ordering",
    advanced: !0
  }]
}, mn = {
  name: "Custom Code",
  static: !0,
  requiredPermissions: ["editCode"],
  inputs: [{
    name: "code",
    type: "html",
    required: !0,
    defaultValue: "<p>Hello there, I am custom HTML code!</p>",
    code: !0
  }, {
    name: "replaceNodes",
    type: "boolean",
    helperText: "Preserve server rendered dom nodes",
    advanced: !0
  }, {
    name: "scriptsClientOnly",
    type: "boolean",
    defaultValue: !1,
    helperText: "Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads",
    advanced: !0
  }]
}, hn = b({
  name: "builder-custom-code",
  props: ["replaceNodes", "code"],
  data() {
    return { scriptsInserted: [], scriptsRun: [] };
  },
  mounted() {
    var t;
    if (!((t = this.$refs.elementRef) != null && t.getElementsByTagName) || typeof window > "u")
      return;
    const e = this.$refs.elementRef.getElementsByTagName("script");
    for (let n = 0; n < e.length; n++) {
      const o = e[n];
      if (o.src) {
        if (this.scriptsInserted.includes(o.src))
          continue;
        this.scriptsInserted.push(o.src);
        const i = document.createElement("script");
        i.async = !0, i.src = o.src, document.head.appendChild(i);
      } else if (!o.type || [
        "text/javascript",
        "application/javascript",
        "application/ecmascript"
      ].includes(o.type)) {
        if (this.scriptsRun.includes(o.innerText))
          continue;
        try {
          this.scriptsRun.push(o.innerText), new Function(o.innerText)();
        } catch (i) {
          console.warn("`CustomCode`: Error running script:", i);
        }
      }
    }
  },
  methods: {
    _classStringToObject(e) {
      const t = {};
      if (typeof e != "string")
        return t;
      const n = e.trim().split(/\s+/);
      for (const o of n)
        t[o] = !0;
      return t;
    }
  }
}), fn = ["innerHTML"];
function bn(e, t, n, o, i, r) {
  return d(), u("div", {
    ref: "elementRef",
    class: Ce(
      e._classStringToObject(
        "builder-custom-code" + (e.replaceNodes ? " replace-nodes" : "")
      )
    ),
    innerHTML: e.code
  }, null, 10, fn);
}
const gn = /* @__PURE__ */ g(hn, [["render", bn], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/custom-code/custom-code.vue"]]), yn = {
  name: "Embed",
  static: !0,
  inputs: [{
    name: "url",
    type: "url",
    required: !0,
    defaultValue: "",
    helperText: "e.g. enter a youtube url, google map, etc",
    onChange: (e) => {
      const t = e.get("url");
      if (t)
        return e.set("content", "Loading..."), fetch(`https://iframe.ly/api/iframely?url=${t}&api_key=ae0e60e78201a3f2b0de4b`).then((o) => o.json()).then((o) => {
          e.get("url") === t && (o.html ? e.set("content", o.html) : e.set("content", "Invalid url, please try another"));
        }).catch((o) => {
          e.set("content", "There was an error embedding this URL, please try again or another URL");
        });
      e.delete("content");
    }
  }, {
    name: "content",
    type: "html",
    defaultValue: '<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',
    hideFromUI: !0
  }]
}, kn = ["text/javascript", "application/javascript", "application/ecmascript"], vn = (e) => kn.includes(e.type), Sn = b({
  name: "builder-embed",
  props: ["content"],
  data() {
    return { scriptsInserted: [], scriptsRun: [], ranInitFn: !1 };
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.$refs.elem && !this.ranInitFn && (this.ranInitFn = !0, this.findAndRunScripts());
      },
      immediate: !0
    }
  },
  computed: {
    onUpdateHook0() {
      return {
        0: this.$refs.elem,
        1: this.ranInitFn
      };
    }
  },
  methods: {
    findAndRunScripts() {
      if (!this.$refs.elem || !this.$refs.elem.getElementsByTagName)
        return;
      const e = this.$refs.elem.getElementsByTagName("script");
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n.src && !this.scriptsInserted.includes(n.src)) {
          this.scriptsInserted.push(n.src);
          const o = document.createElement("script");
          o.async = !0, o.src = n.src, document.head.appendChild(o);
        } else if (vn(n) && !this.scriptsRun.includes(n.innerText))
          try {
            this.scriptsRun.push(n.innerText), new Function(n.innerText)();
          } catch (o) {
            console.warn("`Embed`: Error running script:", o);
          }
      }
    }
  }
}), Cn = ["innerHTML"];
function wn(e, t, n, o, i, r) {
  return d(), u("div", {
    class: "builder-embed",
    ref: "elem",
    innerHTML: e.content
  }, null, 8, Cn);
}
const In = /* @__PURE__ */ g(Sn, [["render", wn], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/embed/embed.vue"]]), $n = {
  name: "Fragment",
  static: !0,
  hidden: !0,
  canHaveChildren: !0,
  noWrap: !0
}, Rn = {
  name: "Image",
  static: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  defaultStyles: {
    position: "relative",
    minHeight: "20px",
    minWidth: "20px",
    overflow: "hidden"
  },
  canHaveChildren: !0,
  inputs: [{
    name: "image",
    type: "file",
    bubble: !0,
    allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
    required: !0,
    defaultValue: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a",
    onChange: (e) => {
      e.delete("srcset"), e.delete("noWebp");
      function n(s, a = 6e4) {
        return new Promise((l, c) => {
          const p = document.createElement("img");
          let h = !1;
          p.onload = () => {
            h = !0, l(p);
          }, p.addEventListener("error", (m) => {
            console.warn("Image load failed", m.error), c(m.error);
          }), p.src = s, setTimeout(() => {
            h || c(new Error("Image load timed out"));
          }, a);
        });
      }
      function o(s) {
        return Math.round(s * 1e3) / 1e3;
      }
      const i = e.get("image"), r = e.get("aspectRatio");
      if (fetch(i).then((s) => s.blob()).then((s) => {
        s.type.includes("svg") && e.set("noWebp", !0);
      }), i && (!r || r === 0.7041))
        return n(i).then((s) => {
          const a = e.get("aspectRatio");
          e.get("image") === i && (!a || a === 0.7041) && s.width && s.height && (e.set("aspectRatio", o(s.height / s.width)), e.set("height", s.height), e.set("width", s.width));
        });
    }
  }, {
    name: "backgroundSize",
    type: "text",
    defaultValue: "cover",
    enum: [{
      label: "contain",
      value: "contain",
      helperText: "The image should never get cropped"
    }, {
      label: "cover",
      value: "cover",
      helperText: "The image should fill it's box, cropping when needed"
    }]
  }, {
    name: "backgroundPosition",
    type: "text",
    defaultValue: "center",
    enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "altText",
    type: "string",
    helperText: "Text to display when the user has images off"
  }, {
    name: "height",
    type: "number",
    hideFromUI: !0
  }, {
    name: "width",
    type: "number",
    hideFromUI: !0
  }, {
    name: "sizes",
    type: "string",
    hideFromUI: !0
  }, {
    name: "srcset",
    type: "string",
    hideFromUI: !0
  }, {
    name: "lazy",
    type: "boolean",
    defaultValue: !0,
    hideFromUI: !0
  }, {
    name: "fitContent",
    type: "boolean",
    helperText: "When child blocks are provided, fit to them instead of using the image's aspect ratio",
    defaultValue: !0
  }, {
    name: "aspectRatio",
    type: "number",
    helperText: "This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",
    advanced: !0,
    defaultValue: 0.7041
  }]
}, Tn = {
  name: "Raw:Img",
  hideFromInsertMenu: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  inputs: [{
    name: "image",
    bubble: !0,
    type: "file",
    allowedFileTypes: ["jpeg", "jpg", "png", "svg", "gif", "webp"],
    required: !0
  }],
  noWrap: !0,
  static: !0
}, xn = b({
  name: "builder-img-component",
  props: [
    "backgroundSize",
    "backgroundPosition",
    "imgSrc",
    "altText",
    "image",
    "attributes"
  ],
  data() {
    return { isEditing: R, filterAttrs: z };
  }
}), En = ["alt", "src"];
function Pn(e, t, n, o, i, r) {
  return d(), u("img", w({
    style: {
      objectFit: e.backgroundSize || "cover",
      objectPosition: e.backgroundPosition || "center"
    },
    key: e.isEditing() && e.imgSrc || "default-key",
    alt: e.altText,
    src: e.imgSrc || e.image
  }, e.filterAttrs(e.attributes, "v-on:", !1), N(e.filterAttrs(e.attributes, "v-on:", !0), !0)), null, 16, En);
}
const An = /* @__PURE__ */ g(xn, [["render", Pn], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/img/img.vue"]]), Bn = {
  name: "Core:Section",
  static: !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a",
  inputs: [{
    name: "maxWidth",
    type: "number",
    defaultValue: 1200
  }, {
    name: "lazyLoad",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    description: "Only render this section when in view"
  }],
  defaultStyles: {
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "50px",
    paddingBottom: "50px",
    marginTop: "0px",
    width: "100vw",
    marginLeft: "calc(50% - 50vw)"
  },
  canHaveChildren: !0,
  defaultChildren: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        textAlign: "center"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"
      }
    }
  }]
}, Vn = {
  name: "Symbol",
  noWrap: !0,
  static: !0,
  isRSC: !0,
  inputs: [{
    name: "symbol",
    type: "uiSymbol"
  }, {
    name: "dataOnly",
    helperText: "Make this a data symbol that doesn't display any UI",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    hideFromUI: !0
  }, {
    name: "inheritState",
    helperText: "Inherit the parent component state and data",
    type: "boolean",
    defaultValue: !1,
    advanced: !0
  }, {
    name: "renderToLiquid",
    helperText: "Render this symbols contents to liquid. Turn off to fetch with javascript and use custom targeting",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    hideFromUI: !0
  }, {
    name: "useChildren",
    hideFromUI: !0,
    type: "boolean"
  }]
}, _n = {
  name: "Text",
  static: !0,
  isRSC: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",
  inputs: [{
    name: "text",
    type: "html",
    required: !0,
    autoFocus: !0,
    bubble: !0,
    defaultValue: "Enter some text..."
  }],
  defaultStyles: {
    lineHeight: "normal",
    height: "auto",
    textAlign: "center"
  }
}, On = b({
  name: "builder-text",
  props: ["text"]
}), jn = ["innerHTML"];
function Nn(e, t, n, o, i, r) {
  var s;
  return d(), u("div", {
    class: "builder-text",
    innerHTML: ((s = e.text) == null ? void 0 : s.toString()) || "",
    style: {
      outline: "none"
    }
  }, null, 8, jn);
}
const Un = /* @__PURE__ */ g(On, [["render", Nn], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/text/text.vue"]]), Fn = {
  name: "Video",
  canHaveChildren: !0,
  defaultStyles: {
    minHeight: "20px",
    minWidth: "20px"
  },
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb",
  inputs: [{
    name: "video",
    type: "file",
    allowedFileTypes: ["mp4"],
    bubble: !0,
    defaultValue: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/assets%2FKQlEmWDxA0coC3PK6UvkrjwkIGI2%2F28cb070609f546cdbe5efa20e931aa4b?alt=media&token=912e9551-7a7c-4dfb-86b6-3da1537d1a7f",
    required: !0
  }, {
    name: "posterImage",
    type: "file",
    allowedFileTypes: ["jpeg", "png"],
    helperText: "Image to show before the video plays"
  }, {
    name: "autoPlay",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "controls",
    type: "boolean",
    defaultValue: !1
  }, {
    name: "muted",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "loop",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "playsInline",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "fit",
    type: "text",
    defaultValue: "cover",
    enum: ["contain", "cover", "fill", "auto"]
  }, {
    name: "preload",
    type: "text",
    defaultValue: "metadata",
    enum: ["auto", "metadata", "none"]
  }, {
    name: "fitContent",
    type: "boolean",
    helperText: "When child blocks are provided, fit to them instead of using the aspect ratio",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "position",
    type: "text",
    defaultValue: "center",
    enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "height",
    type: "number",
    advanced: !0
  }, {
    name: "width",
    type: "number",
    advanced: !0
  }, {
    name: "aspectRatio",
    type: "number",
    advanced: !0,
    defaultValue: 0.7004048582995948
  }, {
    name: "lazyLoad",
    type: "boolean",
    helperText: 'Load this video "lazily" - as in only when a user scrolls near the video. Recommended for optmized performance and bandwidth consumption',
    defaultValue: !0,
    advanced: !0
  }]
}, Wn = b({
  name: "builder-video",
  props: [
    "autoPlay",
    "muted",
    "controls",
    "loop",
    "playsInline",
    "preload",
    "attributes",
    "fit",
    "position",
    "aspectRatio",
    "video",
    "posterImage",
    "lazyLoad",
    "fitContent",
    "builderBlock"
  ],
  computed: {
    videoProps() {
      return {
        ...this.autoPlay === !0 ? {
          autoPlay: !0
        } : {},
        ...this.muted === !0 ? {
          muted: !0
        } : {},
        ...this.controls === !0 ? {
          controls: !0
        } : {},
        ...this.loop === !0 ? {
          loop: !0
        } : {},
        ...this.playsInline === !0 ? {
          playsInline: !0
        } : {}
      };
    },
    spreadProps() {
      return {
        ...this.videoProps
      };
    }
  }
}), Mn = { style: {
  position: "relative"
} }, Ln = ["preload", "src", "poster"], Hn = ["src"], Kn = {
  key: 1,
  style: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  }
}, Dn = {
  key: 2,
  style: {
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%"
  }
};
function zn(e, t, n, o, i, r) {
  var s, a, l, c, p, h, m;
  return d(), u("div", Mn, [
    Q("video", w({
      class: "builder-video",
      preload: e.preload || "metadata",
      style: {
        width: "100%",
        height: "100%",
        ...(s = e.attributes) == null ? void 0 : s.style,
        objectFit: e.fit,
        objectPosition: e.position,
        zIndex: 2,
        borderRadius: "1px",
        ...e.aspectRatio ? {
          position: "absolute"
        } : null
      },
      src: e.video || "no-src",
      poster: e.posterImage
    }, e.spreadProps), [
      e.lazyLoad ? f("v-if", !0) : (d(), u("source", {
        key: 0,
        type: "video/mp4",
        src: e.video
      }, null, 8, Hn))
    ], 16, Ln),
    e.aspectRatio && !(e.fitContent && ((l = (a = e.builderBlock) == null ? void 0 : a.children) == null ? void 0 : l.length)) ? (d(), u("div", {
      key: 0,
      style: X({
        width: "100%",
        paddingTop: e.aspectRatio * 100 + "%",
        pointerEvents: "none",
        fontSize: "0px"
      })
    }, null, 4)) : f("v-if", !0),
    ((p = (c = e.builderBlock) == null ? void 0 : c.children) == null ? void 0 : p.length) && e.fitContent ? (d(), u("div", Kn, [
      P(e.$slots, "default")
    ])) : f("v-if", !0),
    ((m = (h = e.builderBlock) == null ? void 0 : h.children) == null ? void 0 : m.length) && !e.fitContent ? (d(), u("div", Dn, [
      P(e.$slots, "default")
    ])) : f("v-if", !0)
  ]);
}
const qn = /* @__PURE__ */ g(Wn, [["render", zn], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/video/video.vue"]]), pe = () => [{
  component: Ze,
  ...un
}, {
  component: Ut,
  ...pn
}, {
  component: gn,
  ...mn
}, {
  component: In,
  ...yn
}, {
  component: Mt,
  ...$n
}, {
  component: Jt,
  ...Rn
}, {
  component: An,
  ...Tn
}, {
  component: Xt,
  ...Bn
}, {
  component: ti,
  ...Vn
}, {
  component: Un,
  ..._n
}, {
  component: qn,
  ...Fn
}], me = [], Gn = (e) => ({
  type: "builder.registerComponent",
  data: ee(e)
}), Jn = (e) => {
  const t = e.toString().trim();
  return `return (${!t.startsWith("function") && !t.startsWith("(") ? "function " : ""}${t}).apply(this, arguments)`;
}, Yn = (e) => typeof e == "function" ? Jn(e) : F(e), ee = ({
  inputs: e,
  ...t
}) => ({
  ...F(t),
  inputs: e == null ? void 0 : e.map((n) => Object.entries(n).reduce((o, [i, r]) => ({
    ...o,
    [i]: Yn(r)
  }), {}))
}), Qn = `function updateCookiesAndStyles(contentId, variants, isHydrationTarget) {
  function getAndSetVariantId() {
    function setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/' + '; Secure; SameSite=None';
    }
    function getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    const cookieName = \`builder.tests.\${contentId}\`;
    const variantInCookie = getCookie(cookieName);
    const availableIDs = variants.map(vr => vr.id).concat(contentId);
    if (variantInCookie && availableIDs.includes(variantInCookie)) {
      return variantInCookie;
    }
    let n = 0;
    const random = Math.random();
    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const testRatio = variant.testRatio;
      n += testRatio;
      if (random < n) {
        setCookie(cookieName, variant.id);
        return variant.id;
      }
    }
    setCookie(cookieName, contentId);
    return contentId;
  }
  const winningVariantId = getAndSetVariantId();
  const styleEl = document.currentScript?.previousElementSibling;
  if (isHydrationTarget) {
    styleEl.remove();
    const thisScriptEl = document.currentScript;
    thisScriptEl?.remove();
  } else {
    const newStyleStr = variants.concat({
      id: contentId
    }).filter(variant => variant.id !== winningVariantId).map(value => {
      return \`.variant-\${value.id} {  display: none; }
        \`;
    }).join('');
    styleEl.innerHTML = newStyleStr;
  }
}`, Xn = `function updateVariantVisibility(variantContentId, defaultContentId, isHydrationTarget) {
  if (!navigator.cookieEnabled) {
    return;
  }
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  const cookieName = \`builder.tests.\${defaultContentId}\`;
  const winningVariant = getCookie(cookieName);
  const parentDiv = document.currentScript?.parentElement;
  const isDefaultContent = variantContentId === defaultContentId;
  const isWinningVariant = winningVariant === variantContentId;
  if (isWinningVariant && !isDefaultContent) {
    parentDiv?.removeAttribute('hidden');
    parentDiv?.removeAttribute('aria-hidden');
  } else if (!isWinningVariant && isDefaultContent) {
    parentDiv?.setAttribute('hidden', 'true');
    parentDiv?.setAttribute('aria-hidden', 'true');
  }
  if (isHydrationTarget) {
    if (!isWinningVariant) {
      parentDiv?.remove();
    }
    const thisScriptEl = document.currentScript;
    thisScriptEl?.remove();
  }
  return;
}`, Oe = "builderIoAbTest", je = "builderIoRenderContent", L = (e) => Object.values((e == null ? void 0 : e.variations) || {}).map((t) => ({
  ...t,
  testVariationId: t.id,
  id: e == null ? void 0 : e.id
})), Zn = ({
  canTrack: e,
  content: t
}) => !(!(L(t).length > 0) || !e), eo = (e) => e === "react" || e === "reactNative", Ne = eo(x), to = () => `
  window.${Oe} = ${Qn}
  window.${je} = ${Xn}
  `, no = (e, t) => `
  window.${Oe}(
    "${t}",${JSON.stringify(e)}, ${Ne}
  )`, oo = ({
  contentId: e,
  variationId: t
}) => `window.${je}(
    "${t}", "${e}", ${Ne}
  )`, io = b({
  render() {
    return Se("script", { id: this.id, innerHTML: this.scriptStr });
  },
  name: "inlined-script",
  props: ["scriptStr", "id"]
}), Ue = /* @__PURE__ */ g(io, [["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/inlined-script.vue"]]);
function ro() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : globalThis;
}
function so() {
  const e = ro().fetch;
  if (typeof e > "u")
    throw console.warn(`Builder SDK could not find a global fetch function. Make sure you have a polyfill for fetch in your project. 
      For more information, read https://github.com/BuilderIO/this-package-uses-fetch`), new Error("Builder SDK could not find a global `fetch` function");
  return e;
}
const Fe = so();
function H(e, t = null, n = ".") {
  return Object.keys(e).reduce((o, i) => {
    const r = e[i], s = [t, i].filter(Boolean).join(n);
    return [typeof r == "object", r !== null, !(Array.isArray(r) && r.length === 0)].every(Boolean) ? {
      ...o,
      ...H(r, s, n)
    } : {
      ...o,
      [s]: r
    };
  }, {});
}
const ao = "v3", he = "builder.", lo = "options.", co = (e) => {
  const t = {};
  return e.forEach((n, o) => {
    t[o] = n;
  }), t;
}, We = (e) => {
  if (!e)
    return {};
  const t = Me(e), n = {};
  return Object.keys(t).forEach((o) => {
    if (o.startsWith(he)) {
      const i = o.replace(he, "").replace(lo, "");
      n[i] = t[o];
    }
  }), n;
}, uo = () => {
  if (!v())
    return {};
  const e = new URLSearchParams(window.location.search);
  return We(e);
}, Me = (e) => e instanceof URLSearchParams ? co(e) : e, fe = (e) => typeof e == "number" && !isNaN(e) && e >= 0, re = (e) => {
  let {
    noTraverse: t = !1
  } = e;
  const {
    limit: n = 30,
    userAttributes: o,
    query: i,
    model: r,
    apiKey: s,
    includeRefs: a = !0,
    enrich: l,
    locale: c,
    apiVersion: p = ao,
    fields: h,
    omit: m,
    offset: S,
    cacheSeconds: V,
    staleCacheSeconds: _,
    sort: O,
    includeUnpublished: se
  } = e;
  if (!s)
    throw new Error("Missing API key");
  if (!["v2", "v3"].includes(p))
    throw new Error(`Invalid apiVersion: expected 'v2' or 'v3', received '${p}'`);
  (e.limit === void 0 || e.limit > 1) && !("noTraverse" in e) && (t = !0);
  const I = new URL(`https://cdn.builder.io/api/${p}/content/${r}?apiKey=${s}&limit=${n}&noTraverse=${t}&includeRefs=${a}${c ? `&locale=${c}` : ""}${l ? `&enrich=${l}` : ""}`);
  if (I.searchParams.set("omit", m || "meta.componentsUsed"), h && I.searchParams.set("fields", h), Number.isFinite(S) && S > -1 && I.searchParams.set("offset", String(Math.floor(S))), typeof se == "boolean" && I.searchParams.set("includeUnpublished", String(se)), V && fe(V) && I.searchParams.set("cacheSeconds", String(V)), _ && fe(_) && I.searchParams.set("staleCacheSeconds", String(_)), O) {
    const E = H({
      sort: O
    });
    for (const j in E)
      I.searchParams.set(j, JSON.stringify(E[j]));
  }
  const Ge = {
    ...uo(),
    ...Me(e.options || {})
  }, ae = H(Ge);
  for (const E in ae)
    I.searchParams.set(E, String(ae[E]));
  if (o && I.searchParams.set("userAttributes", JSON.stringify(o)), i) {
    const E = H({
      query: i
    });
    for (const j in E)
      I.searchParams.set(j, JSON.stringify(E[j]));
  }
  return I;
}, po = (e) => "results" in e;
async function G(e) {
  const t = await Le({
    ...e,
    limit: 1
  });
  return t && t.results[0] || null;
}
const ii = G, mo = async (e) => {
  const t = re(e);
  return await (await Fe(t.href)).json();
}, ho = async (e, t, n = re(e)) => {
  const o = U(e.canTrack);
  if (n.search.includes("preview="), !o || !(v() || x === "reactNative"))
    return t;
  try {
    const i = [];
    for (const r of t.results)
      i.push(await dn({
        item: r,
        canTrack: o
      }));
    t.results = i;
  } catch (i) {
    $.error("Could not process A/B tests. ", i);
  }
  return t;
};
async function Le(e) {
  try {
    const t = re(e), n = await mo(e);
    return po(n) ? ho(e, n) : ($.error("Error fetching data. ", {
      url: t,
      content: n,
      options: e
    }), null);
  } catch (t) {
    return $.error("Error fetching data. ", t), null;
  }
}
const ri = Le;
function fo() {
  return !v() || R() ? !1 : Boolean(location.search.indexOf("builder.preview=") !== -1);
}
function bo() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const t = Math.random() * 16 | 0;
    return (e == "x" ? t : t & 3 | 8).toString(16);
  });
}
function He() {
  return bo().replace(/-/g, "");
}
const Ke = "builderSessionId", go = async ({
  canTrack: e
}) => {
  if (!e)
    return;
  const t = await Pe({
    name: Ke,
    canTrack: e
  });
  if (T(t))
    return t;
  {
    const n = yo();
    return ko({
      id: n,
      canTrack: e
    }), n;
  }
}, yo = () => He(), ko = ({
  id: e,
  canTrack: t
}) => Ae({
  name: Ke,
  value: e,
  canTrack: t
}), De = () => v() && typeof localStorage < "u" ? localStorage : void 0, vo = ({
  key: e,
  canTrack: t
}) => {
  var n;
  try {
    return t ? (n = De()) == null ? void 0 : n.getItem(e) : void 0;
  } catch (o) {
    console.debug("[LocalStorage] GET error: ", o);
    return;
  }
}, So = ({
  key: e,
  canTrack: t,
  value: n
}) => {
  var o;
  try {
    t && ((o = De()) == null || o.setItem(e, n));
  } catch (i) {
    console.debug("[LocalStorage] SET error: ", i);
  }
}, ze = "builderVisitorId", Co = ({
  canTrack: e
}) => {
  if (!e)
    return;
  const t = vo({
    key: ze,
    canTrack: e
  });
  if (T(t))
    return t;
  {
    const n = wo();
    return Io({
      id: n,
      canTrack: e
    }), n;
  }
}, wo = () => He(), Io = ({
  id: e,
  canTrack: t
}) => So({
  key: ze,
  value: e,
  canTrack: t
}), $o = async ({
  canTrack: e
}) => {
  if (!e)
    return {
      visitorId: void 0,
      sessionId: void 0
    };
  const t = await go({
    canTrack: e
  }), n = Co({
    canTrack: e
  });
  return {
    sessionId: t,
    visitorId: n
  };
}, Ro = async ({
  type: e,
  canTrack: t,
  apiKey: n,
  metadata: o,
  ...i
}) => ({
  type: e,
  data: {
    ...i,
    metadata: {
      url: location.href,
      ...o
    },
    ...await $o({
      canTrack: t
    }),
    userAttributes: Ie(),
    ownerId: n
  }
});
async function te(e) {
  if (!e.apiKey) {
    $.error("Missing API key for track call. Please provide your API key.");
    return;
  }
  if (!!e.canTrack && !R() && !!(v() || x === "reactNative"))
    return fetch("https://cdn.builder.io/api/v1/track", {
      method: "POST",
      body: JSON.stringify({
        events: [await Ro(e)]
      }),
      headers: {
        "content-type": "application/json"
      },
      mode: "cors"
    }).catch((t) => {
      console.error("Failed to track: ", t);
    });
}
const si = (e) => te({
  ...e,
  canTrack: !0
});
function be(e) {
  return Math.round(e * 1e3) / 1e3;
}
const To = (e, t, n = !0) => {
  if (!(e instanceof HTMLElement))
    return null;
  let o = n ? e : e.parentElement;
  do {
    if (!o)
      return null;
    if (t(o))
      return o;
  } while (o = o.parentElement);
  return null;
}, xo = (e) => To(e, (t) => {
  const n = t.getAttribute("builder-id") || t.id;
  return Boolean((n == null ? void 0 : n.indexOf("builder-")) === 0);
}), ge = ({
  event: e,
  target: t
}) => {
  const n = t.getBoundingClientRect(), o = e.clientX - n.left, i = e.clientY - n.top, r = be(o / n.width), s = be(i / n.height);
  return {
    x: r,
    y: s
  };
}, Eo = (e) => {
  const t = e.target, n = t && xo(t), o = (n == null ? void 0 : n.getAttribute("builder-id")) || (n == null ? void 0 : n.id);
  return {
    targetBuilderElement: o || void 0,
    metadata: {
      targetOffset: t ? ge({
        event: e,
        target: t
      }) : void 0,
      builderTargetOffset: n ? ge({
        event: e,
        target: n
      }) : void 0,
      builderElementIndex: n && o ? [].slice.call(document.getElementsByClassName(o)).indexOf(n) : void 0
    }
  };
}, Po = "0.7.6", ye = {};
function Ao(e, t) {
  let n = ye[e];
  if (n || (n = ye[e] = []), n.push(t), v()) {
    const o = {
      type: "builder.register",
      data: {
        type: e,
        info: t
      }
    };
    try {
      parent.postMessage(o, "*"), parent !== window && window.postMessage(o, "*");
    } catch (i) {
      console.debug("Could not postmessage", i);
    }
  }
}
const Bo = () => {
  Ao("insertMenu", {
    name: "_default",
    default: !0,
    items: [{
      name: "Box"
    }, {
      name: "Text"
    }, {
      name: "Image"
    }, {
      name: "Columns"
    }, {
      name: "Core:Section"
    }, {
      name: "Core:Button"
    }, {
      name: "Embed"
    }, {
      name: "Custom Code"
    }]
  });
};
let ke = !1;
const Vo = (e = {}) => {
  var t, n;
  ke || (ke = !0, v() && ((t = window.parent) == null || t.postMessage({
    type: "builder.sdkInfo",
    data: {
      target: x,
      version: Po,
      supportsPatchUpdates: !1,
      supportsAddBlockScoping: !0,
      supportsCustomBreakpoints: !0
    }
  }, "*"), (n = window.parent) == null || n.postMessage({
    type: "builder.updateContent",
    data: {
      options: e
    }
  }, "*"), window.addEventListener("message", ({
    data: o
  }) => {
    var i, r;
    if (!!(o != null && o.type))
      switch (o.type) {
        case "builder.evaluate": {
          const s = o.data.text, a = o.data.arguments || [], l = o.data.id, c = new Function(s);
          let p, h = null;
          try {
            p = c.apply(null, a);
          } catch (m) {
            h = m;
          }
          h ? (i = window.parent) == null || i.postMessage({
            type: "builder.evaluateError",
            data: {
              id: l,
              error: h.message
            }
          }, "*") : p && typeof p.then == "function" ? p.then((m) => {
            var S;
            (S = window.parent) == null || S.postMessage({
              type: "builder.evaluateResult",
              data: {
                id: l,
                result: m
              }
            }, "*");
          }).catch(console.error) : (r = window.parent) == null || r.postMessage({
            type: "builder.evaluateResult",
            data: {
              result: p,
              id: l
            }
          }, "*");
          break;
        }
      }
  })));
}, _o = b({
  name: "enable-editor",
  props: [
    "builderContextSignal",
    "model",
    "context",
    "canTrack",
    "apiKey",
    "locale",
    "includeRefs",
    "enrich",
    "content",
    "showContent"
  ],
  data() {
    return {
      forceReRenderCount: 0,
      lastUpdated: 0,
      shouldSendResetCookie: !1,
      httpReqsData: {},
      clicked: !1,
      builderContext: Z
    };
  },
  provide() {
    const e = this;
    return {
      [Z.key]: e.builderContextSignal
    };
  },
  mounted() {
    (() => {
      var n, o;
      if (v()) {
        if (R() && this.$refs.elementRef && this.$refs.elementRef.dispatchEvent(
          new CustomEvent("initeditingbldr")
        ), this.builderContextSignal.content && U(this.canTrack)) {
          const r = (n = this.builderContextSignal.content) == null ? void 0 : n.testVariationId, s = (o = this.builderContextSignal.content) == null ? void 0 : o.id, a = this.apiKey;
          te({
            type: "impression",
            canTrack: !0,
            contentId: s,
            apiKey: a,
            variationId: r !== s ? r : void 0
          });
        }
        fo() && this.$refs.elementRef && this.$refs.elementRef.dispatchEvent(
          new CustomEvent("initpreviewingbldr")
        );
      }
    })(), (() => {
      this.apiKey || $.error(
        "No API key provided to `RenderContent` component. This can cause issues. Please provide an API key using the `apiKey` prop."
      ), this.evaluateJsCode(), this.runHttpRequests(), this.emitStateUpdate();
    })();
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.content && this.mergeNewContent(this.content);
      },
      immediate: !0
    },
    onUpdateHook1: { handler() {
    }, immediate: !0 },
    onUpdateHook2: {
      handler() {
        this.evaluateJsCode();
      },
      immediate: !0
    },
    onUpdateHook3: {
      handler() {
        this.runHttpRequests();
      },
      immediate: !0
    },
    onUpdateHook4: {
      handler() {
        this.emitStateUpdate();
      },
      immediate: !0
    }
  },
  unmounted() {
    v() && (window.removeEventListener("message", this.processMessage), window.removeEventListener(
      "builder:component:stateChangeListenerActivated",
      this.emitStateUpdate
    ));
  },
  computed: {
    onUpdateHook0() {
      return {
        0: this.content
      };
    },
    onUpdateHook1() {
      return {
        0: this.shouldSendResetCookie
      };
    },
    onUpdateHook2() {
      var e, t;
      return {
        0: (t = (e = this.builderContextSignal.content) == null ? void 0 : e.data) == null ? void 0 : t.jsCode,
        1: this.builderContextSignal.rootState
      };
    },
    onUpdateHook3() {
      var e, t;
      return {
        0: (t = (e = this.builderContextSignal.content) == null ? void 0 : e.data) == null ? void 0 : t.httpRequests
      };
    },
    onUpdateHook4() {
      return {
        0: this.builderContextSignal.rootState
      };
    }
  },
  methods: {
    mergeNewContent(e) {
      var n, o, i, r, s;
      const t = {
        ...this.builderContextSignal.content,
        ...e,
        data: {
          ...(n = this.builderContextSignal.content) == null ? void 0 : n.data,
          ...e == null ? void 0 : e.data
        },
        meta: {
          ...(o = this.builderContextSignal.content) == null ? void 0 : o.meta,
          ...e == null ? void 0 : e.meta,
          breakpoints: ((i = e == null ? void 0 : e.meta) == null ? void 0 : i.breakpoints) || ((s = (r = this.builderContextSignal.content) == null ? void 0 : r.meta) == null ? void 0 : s.breakpoints)
        }
      };
      this.builderContextSignal.content = t;
    },
    processMessage(e) {
      var n;
      const { data: t } = e;
      if (t)
        switch (t.type) {
          case "builder.configureSdk": {
            const o = t.data, { breakpoints: i, contentId: r } = o;
            if (!r || r !== ((n = this.builderContextSignal.content) == null ? void 0 : n.id))
              return;
            i && this.mergeNewContent({
              meta: {
                breakpoints: i
              }
            }), this.forceReRenderCount = this.forceReRenderCount + 1;
            break;
          }
          case "builder.contentUpdate": {
            const o = t.data, i = o.key || o.alias || o.entry || o.modelName, r = o.data;
            i === this.model && (this.mergeNewContent(r), this.forceReRenderCount = this.forceReRenderCount + 1);
            break;
          }
        }
    },
    evaluateJsCode() {
      var t, n;
      const e = (n = (t = this.builderContextSignal.content) == null ? void 0 : t.data) == null ? void 0 : n.jsCode;
      e && K({
        code: e,
        context: this.context || {},
        localState: void 0,
        rootState: this.builderContextSignal.rootState,
        rootSetState: this.builderContextSignal.rootSetState
      });
    },
    onClick(e) {
      var t, n;
      if (this.builderContextSignal.content) {
        const o = (t = this.builderContextSignal.content) == null ? void 0 : t.testVariationId, i = (n = this.builderContextSignal.content) == null ? void 0 : n.id;
        te({
          type: "click",
          canTrack: U(this.canTrack),
          contentId: i,
          apiKey: this.apiKey,
          variationId: o !== i ? o : void 0,
          ...Eo(e),
          unique: !this.clicked
        });
      }
      this.clicked || (this.clicked = !0);
    },
    evalExpression(e) {
      return e.replace(
        /{{([^}]+)}}/g,
        (t, n) => K({
          code: n,
          context: this.context || {},
          localState: void 0,
          rootState: this.builderContextSignal.rootState,
          rootSetState: this.builderContextSignal.rootSetState
        })
      );
    },
    handleRequest({ url: e, key: t }) {
      Fe(e).then((n) => n.json()).then((n) => {
        var i, r;
        const o = {
          ...this.builderContextSignal.rootState,
          [t]: n
        };
        (r = (i = this.builderContextSignal).rootSetState) == null || r.call(i, o), this.httpReqsData[t] = !0;
      }).catch((n) => {
        console.error("error fetching dynamic data", e, n);
      });
    },
    runHttpRequests() {
      var t, n, o;
      const e = (o = (n = (t = this.builderContextSignal.content) == null ? void 0 : t.data) == null ? void 0 : n.httpRequests) != null ? o : {};
      Object.entries(e).forEach(([i, r]) => {
        if (r && (!this.httpReqsData[i] || R())) {
          const s = this.evalExpression(r);
          this.handleRequest({
            url: s,
            key: i
          });
        }
      });
    },
    emitStateUpdate() {
      R() && window.dispatchEvent(
        new CustomEvent(
          "builder:component:stateChange",
          {
            detail: {
              state: F(this.builderContextSignal.rootState),
              ref: {
                name: this.model
              }
            }
          }
        )
      );
    },
    elementRef_onIniteditingbldr(e) {
      this.forceReRenderCount = this.forceReRenderCount + 1, window.addEventListener("message", this.processMessage), Bo(), Vo({
        ...this.locale ? {
          locale: this.locale
        } : {},
        ...this.includeRefs ? {
          includeRefs: this.includeRefs
        } : {},
        ...this.enrich ? {
          enrich: this.enrich
        } : {}
      }), Object.values(
        this.builderContextSignal.componentInfos
      ).forEach((t) => {
        var o;
        const n = Gn(t);
        (o = window.parent) == null || o.postMessage(n, "*");
      }), window.addEventListener(
        "builder:component:stateChangeListenerActivated",
        this.emitStateUpdate
      );
    },
    elementRef_onInitpreviewingbldr(e) {
      const t = new URL(location.href).searchParams, n = t.get("builder.preview"), o = t.get(
        `builder.preview.${n}`
      ), i = t.get("apiKey") || t.get("builder.space");
      n === this.model && i === this.apiKey && (!this.content || o === this.content.id) && G({
        model: this.model,
        apiKey: this.apiKey,
        apiVersion: this.builderContextSignal.apiVersion
      }).then((r) => {
        r && this.mergeNewContent(r);
      });
    },
    _classStringToObject(e) {
      const t = {};
      if (typeof e != "string")
        return t;
      const n = e.trim().split(/\s+/);
      for (const o of n)
        t[o] = !0;
      return t;
    }
  }
}), Oo = ["builder-content-id", "builder-model"];
function jo(e, t, n, o, i, r) {
  var s, a, l;
  return e.builderContextSignal.content ? (d(), u("div", w({
    key: e.forceReRenderCount,
    ref: "elementRef",
    onClick: t[0] || (t[0] = (c) => e.onClick(c)),
    "builder-content-id": (s = e.builderContextSignal.content) == null ? void 0 : s.id,
    "builder-model": e.model,
    class: e._classStringToObject(
      `variant-${((a = e.content) == null ? void 0 : a.testVariationId) || ((l = e.content) == null ? void 0 : l.id)}`
    ),
    onIniteditingbldr: t[1] || (t[1] = (c) => e.elementRef_onIniteditingbldr(c)),
    onInitpreviewingbldr: t[2] || (t[2] = (c) => e.elementRef_onInitpreviewingbldr(c))
  }, {
    ...e.showContent ? {} : {
      hidden: !0,
      "aria-hidden": !0
    }
  }), [
    P(e.$slots, "default")
  ], 16, Oo)) : f("v-if", !0);
}
const No = /* @__PURE__ */ g(_o, [["render", jo], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/content/components/enable-editor.vue"]]), Uo = (e) => {
  var r, s;
  const t = e.family + (e.kind && !e.kind.includes("#") ? ", " + e.kind : ""), n = t.split(",")[0], o = (s = e.fileUrl) != null ? s : (r = e == null ? void 0 : e.files) == null ? void 0 : r.regular;
  let i = "";
  if (o && t && n && (i += `
@font-face {
font-family: "${t}";
src: local("${n}"), url('${o}') format('woff2');
font-display: fallback;
font-weight: 400;
}
      `.trim()), e.files)
    for (const a in e.files) {
      if (!(String(Number(a)) === a))
        continue;
      const c = e.files[a];
      c && c !== o && (i += `
@font-face {
font-family: "${t}";
src: url('${c}') format('woff2');
font-display: fallback;
font-weight: ${a};
}
        `.trim());
    }
  return i;
}, Fo = ({
  customFonts: e
}) => {
  var t;
  return ((t = e == null ? void 0 : e.map((n) => Uo(n))) == null ? void 0 : t.join(" ")) || "";
}, Wo = ({
  cssCode: e,
  contentId: t
}) => e ? t ? (e == null ? void 0 : e.replace(/&/g, `div[builder-content-id="${t}"]`)) || "" : e : "", Mo = b({
  name: "content-styles",
  components: { InlinedStyles: q },
  props: ["cssCode", "contentId", "customFonts"],
  data() {
    return {
      injectedStyles: `
${Wo({
        cssCode: this.cssCode,
        contentId: this.contentId
      })}
${Fo({
        customFonts: this.customFonts
      })}

.builder-text > p:first-of-type, .builder-text > .builder-paragraph:first-of-type {
  margin: 0;
}
.builder-text > p, .builder-text > .builder-paragraph {
  color: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-align: inherit;
  font-family: inherit;
}
`.trim()
    };
  }
});
function Lo(e, t, n, o, i, r) {
  const s = y("inlined-styles");
  return d(), k(s, { styles: e.injectedStyles }, null, 8, ["styles"]);
}
const Ho = /* @__PURE__ */ g(Mo, [["render", Lo], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/content/components/styles.vue"]]), Ko = ({
  content: e,
  data: t,
  locale: n
}) => {
  var r, s, a;
  const o = {}, i = ((r = e == null ? void 0 : e.data) == null ? void 0 : r.state) || {};
  return (a = (s = e == null ? void 0 : e.data) == null ? void 0 : s.inputs) == null || a.forEach((l) => {
    l.name && l.defaultValue !== void 0 && (o[l.name] = l.defaultValue);
  }), {
    ...o,
    ...i,
    ...t,
    ...n ? {
      locale: n
    } : {}
  };
}, Do = ({
  content: e,
  data: t
}) => e ? {
  ...e,
  data: {
    ...e == null ? void 0 : e.data,
    ...t
  },
  meta: e == null ? void 0 : e.meta
} : void 0, zo = Je, qo = b({
  name: "content-component",
  components: {
    EnableEditor: No,
    InlinedScript: Ue,
    ContentStyles: Ho,
    Blocks: oe
  },
  props: [
    "content",
    "customComponents",
    "data",
    "locale",
    "context",
    "apiKey",
    "apiVersion",
    "model",
    "canTrack",
    "includeRefs",
    "enrich",
    "showContent",
    "isSsrAbTest"
  ],
  data() {
    var e, t;
    return {
      scriptStr: oo({
        variationId: (e = this.content) == null ? void 0 : e.testVariationId,
        contentId: (t = this.content) == null ? void 0 : t.id
      }),
      registeredComponents: [
        ...pe(),
        ...me,
        ...this.customComponents || []
      ].reduce(
        (n, { component: o, ...i }) => ({
          ...n,
          [i.name]: {
            component: zo(o),
            ...ee(i)
          }
        }),
        {}
      ),
      builderContextSignal: {
        content: Do({
          content: this.content,
          data: this.data
        }),
        localState: void 0,
        rootState: Ko({
          content: this.content,
          data: this.data,
          locale: this.locale
        }),
        rootSetState: this.contentSetState,
        context: this.context || {},
        apiKey: this.apiKey,
        apiVersion: this.apiVersion,
        componentInfos: [
          ...pe(),
          ...me,
          ...this.customComponents || []
        ].reduce(
          (n, { component: o, ...i }) => ({
            ...n,
            [i.name]: ee(i)
          }),
          {}
        ),
        inheritedStyles: {}
      },
      TARGET: x
    };
  },
  provide() {
    const e = this;
    return {
      [we.key]: {
        registeredComponents: e.registeredComponents
      }
    };
  },
  methods: {
    contentSetState(e) {
      this.builderContextSignal.rootState = e;
    }
  }
});
function Go(e, t, n, o, i, r) {
  const s = y("inlined-script"), a = y("content-styles"), l = y("blocks"), c = y("enable-editor");
  return d(), k(c, w({
    content: e.content,
    model: e.model,
    context: e.context,
    apiKey: e.apiKey,
    canTrack: e.canTrack,
    locale: e.locale,
    includeRefs: e.includeRefs,
    enrich: e.enrich,
    showContent: e.showContent,
    builderContextSignal: e.builderContextSignal
  }, {}), {
    default: ne(() => {
      var p, h, m, S, V, _, O;
      return [
        e.isSsrAbTest ? (d(), k(s, {
          key: 0,
          scriptStr: e.scriptStr
        }, null, 8, ["scriptStr"])) : f("v-if", !0),
        e.TARGET !== "reactNative" ? (d(), k(a, {
          key: 1,
          contentId: (p = e.builderContextSignal.content) == null ? void 0 : p.id,
          cssCode: (m = (h = e.builderContextSignal.content) == null ? void 0 : h.data) == null ? void 0 : m.cssCode,
          customFonts: (V = (S = e.builderContextSignal.content) == null ? void 0 : S.data) == null ? void 0 : V.customFonts
        }, null, 8, ["contentId", "cssCode", "customFonts"])) : f("v-if", !0),
        B(l, {
          blocks: (O = (_ = e.builderContextSignal.content) == null ? void 0 : _.data) == null ? void 0 : O.blocks,
          context: e.builderContextSignal,
          registeredComponents: e.registeredComponents
        }, null, 8, ["blocks", "context", "registeredComponents"])
      ];
    }),
    _: 1
  }, 16, ["content", "model", "context", "apiKey", "canTrack", "locale", "includeRefs", "enrich", "showContent", "builderContextSignal"]);
}
const Jo = /* @__PURE__ */ g(qo, [["render", Go], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/content/content.vue"]]), Yo = b({
  name: "content-variants",
  components: {
    InlinedScript: Ue,
    InlinedStyles: q,
    ContentComponent: Jo
  },
  props: [
    "canTrack",
    "content",
    "__isNestedRender",
    "model",
    "data",
    "context",
    "apiKey",
    "apiVersion",
    "customComponents",
    "locale",
    "includeRefs",
    "enrich"
  ],
  data() {
    return {
      shouldRenderVariants: Zn({
        canTrack: U(this.canTrack),
        content: this.content
      }),
      TARGET: x,
      getScriptString: to,
      getVariants: L
    };
  },
  mounted() {
    this.shouldRenderVariants = !1;
  },
  computed: {
    updateCookieAndStylesScriptStr() {
      var e;
      return no(
        L(this.content).map((t) => ({
          id: t.testVariationId,
          testRatio: t.testRatio
        })),
        ((e = this.content) == null ? void 0 : e.id) || ""
      );
    },
    hideVariantsStyleString() {
      return L(this.content).map((e) => `.variant-${e.testVariationId} { display: none; } `).join("");
    },
    defaultContent() {
      var e;
      return this.shouldRenderVariants ? {
        ...this.content,
        testVariationId: (e = this.content) == null ? void 0 : e.id
      } : cn({
        item: this.content,
        canTrack: U(this.canTrack)
      });
    }
  }
});
function Qo(e, t, n, o, i, r) {
  var c;
  const s = y("inlined-script"), a = y("inlined-styles"), l = y("content-component");
  return d(), u(C, null, [
    !e.__isNestedRender && e.TARGET !== "reactNative" ? (d(), k(s, {
      key: 0,
      scriptStr: e.getScriptString()
    }, null, 8, ["scriptStr"])) : f("v-if", !0),
    e.shouldRenderVariants ? (d(), u(C, { key: 1 }, [
      B(a, {
        id: `variants-styles-${(c = e.content) == null ? void 0 : c.id}`,
        styles: e.hideVariantsStyleString
      }, null, 8, ["id", "styles"]),
      B(s, { scriptStr: e.updateCookieAndStylesScriptStr }, null, 8, ["scriptStr"]),
      (d(!0), u(C, null, A(e.getVariants(e.content), (p, h) => (d(), k(l, {
        key: p.testVariationId,
        content: p,
        showContent: !1,
        model: e.model,
        data: e.data,
        context: e.context,
        apiKey: e.apiKey,
        apiVersion: e.apiVersion,
        customComponents: e.customComponents,
        canTrack: e.canTrack,
        locale: e.locale,
        includeRefs: e.includeRefs,
        enrich: e.enrich,
        isSsrAbTest: e.shouldRenderVariants
      }, null, 8, ["content", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "canTrack", "locale", "includeRefs", "enrich", "isSsrAbTest"]))), 128))
    ], 64)) : f("v-if", !0),
    B(l, w({
      content: e.defaultContent,
      showContent: !0,
      model: e.model,
      data: e.data,
      context: e.context,
      apiKey: e.apiKey,
      apiVersion: e.apiVersion,
      customComponents: e.customComponents,
      canTrack: e.canTrack,
      locale: e.locale,
      includeRefs: e.includeRefs,
      enrich: e.enrich,
      isSsrAbTest: e.shouldRenderVariants
    }, {
      key: e.shouldRenderVariants.toString()
    }), null, 16, ["content", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "canTrack", "locale", "includeRefs", "enrich", "isSsrAbTest"])
  ], 64);
}
const qe = /* @__PURE__ */ g(Yo, [["render", Qo], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/components/content-variants/content-variants.vue"]]), Xo = async ({
  builderContextValue: e,
  symbol: t
}) => {
  if ((t == null ? void 0 : t.model) && (e == null ? void 0 : e.apiKey))
    return G({
      model: t.model,
      apiKey: e.apiKey,
      apiVersion: e.apiVersion,
      ...(t == null ? void 0 : t.entry) && {
        query: {
          id: t.entry
        }
      }
    }).catch((n) => {
      $.error("Could not fetch symbol content: ", n);
    });
}, Zo = b({
  name: "builder-symbol",
  components: { ContentVariants: qe },
  props: [
    "js",
    "attributes",
    "symbol",
    "dynamic",
    "builderContext",
    "builderComponents"
  ],
  data() {
    var e;
    return { contentToUse: (e = this.symbol) == null ? void 0 : e.content, filterAttrs: z };
  },
  mounted() {
    this.setContent();
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.setContent();
      },
      immediate: !0
    }
  },
  computed: {
    className() {
      var e, t;
      return [
        ...Object.keys(this.attributes.class),
        "builder-symbol",
        (e = this.symbol) != null && e.inline ? "builder-inline-symbol" : void 0,
        ((t = this.symbol) == null ? void 0 : t.dynamic) || this.dynamic ? "builder-dynamic-symbol" : void 0
      ].filter(Boolean).join(" ");
    },
    onUpdateHook0() {
      return {
        0: this.symbol
      };
    }
  },
  methods: {
    setContent() {
      this.contentToUse || Xo({
        symbol: this.symbol,
        builderContextValue: this.builderContext
      }).then((e) => {
        e && (this.contentToUse = e);
      });
    },
    _classStringToObject(e) {
      const t = {};
      if (typeof e != "string")
        return t;
      const n = e.trim().split(/\s+/);
      for (const o of n)
        t[o] = !0;
      return t;
    }
  }
});
function ei(e, t, n, o, i, r) {
  var a, l, c, p;
  const s = y("content-variants");
  return d(), u("div", w({
    class: e._classStringToObject(e.className)
  }, { ...e.filterAttrs(e.attributes, "v-on:", !1) }, N(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    B(s, {
      __isNestedRender: !0,
      apiVersion: e.builderContext.apiVersion,
      apiKey: e.builderContext.apiKey,
      context: e.builderContext.context,
      customComponents: Object.values(e.builderComponents),
      data: {
        ...(a = e.symbol) == null ? void 0 : a.data,
        ...e.builderContext.localState,
        ...(c = (l = e.contentToUse) == null ? void 0 : l.data) == null ? void 0 : c.state
      },
      model: (p = e.symbol) == null ? void 0 : p.model,
      content: e.contentToUse
    }, null, 8, ["apiVersion", "apiKey", "context", "customComponents", "data", "model", "content"])
  ], 16);
}
const ti = /* @__PURE__ */ g(Zo, [["render", ei], ["__file", "/home/runner/work/builder/builder/packages/sdks/output/vue/vue3/src/blocks/symbol/symbol.vue"]]), ai = oe, li = qe, ve = {};
function ci(e) {
  if (v()) {
    Object.assign(ve, e);
    const t = {
      type: "builder.settingsChange",
      data: ve
    };
    parent.postMessage(t, "*");
  }
}
const di = async (e) => {
  var o, i, r;
  const t = e.path || ((o = e.url) == null ? void 0 : o.pathname) || ((i = e.userAttributes) == null ? void 0 : i.urlPath), n = {
    ...e,
    apiKey: e.apiKey,
    model: e.model || "page",
    userAttributes: {
      ...e.userAttributes,
      ...t ? {
        urlPath: t
      } : {}
    },
    options: We(e.searchParams || ((r = e.url) == null ? void 0 : r.searchParams) || e.options)
  };
  return {
    apiKey: n.apiKey,
    model: n.model,
    content: await G(n)
  };
};
export {
  $e as B,
  qe as C,
  Mt as F,
  Jt as I,
  ai as R,
  Xt as S,
  x as T,
  qn as V,
  g as _,
  xe as a,
  Z as b,
  it as c,
  oe as d,
  K as e,
  li as f,
  Ze as g,
  Ut as h,
  ti as i,
  Un as j,
  R as k,
  fo as l,
  Gn as m,
  ho as n,
  Le as o,
  G as p,
  ri as q,
  Ao as r,
  ci as s,
  ii as t,
  We as u,
  si as v,
  zo as w,
  di as x,
  oi as y
};
